import { combineReducers } from '@reduxjs/toolkit';
import {
  authApi,
  dashboardApi,
  integrationsApi,
  eventLogsApi,
  supportTicketsApi,
  usersApi,
  clientsApi,
  profileApi,
  settingsApi,
  subscriptionPlansApi,
} from '../api/baseApis';
import projectApi from '../api/projectsApi';

const rootReducer = combineReducers({
  [authApi.reducerPath]: authApi.reducer,
  [dashboardApi.reducerPath]: dashboardApi.reducer,
  [integrationsApi.reducerPath]: integrationsApi.reducer,
  [eventLogsApi.reducerPath]: eventLogsApi.reducer,
  [supportTicketsApi.reducerPath]: supportTicketsApi.reducer,
  [usersApi.reducerPath]: usersApi.reducer,
  [clientsApi.reducerPath]: clientsApi.reducer,
  [profileApi.reducerPath]: profileApi.reducer,
  [settingsApi.reducerPath]: settingsApi.reducer,
  [subscriptionPlansApi.reducerPath]: subscriptionPlansApi.reducer,
  [projectApi.reducerPath]: projectApi.reducer,
});

export default rootReducer;
